import { useQuery } from '@tanstack/react-query';
import { api } from './api';
export type FriendProfile = { id: string; name: string; email: string };
export type SharedDebt = {
  id: string;
  creditorId: string;
  debtorId: string;
  creditor: FriendProfile;
  debtor: FriendProfile;
  amountCents: number;
  currency: string;
  description: string;
  date: string;
  dueDate: string | null;
  status: 'OPEN' | 'REPAYMENT_REQUESTED' | 'DISPUTED' | 'SETTLED' | 'CANCELLED';
  disputeReason: string | null;
  repaymentDate: string | null;
  updatedAt: string;
};
export type FriendsData = {
  friends: Array<{ id: string; user: FriendProfile }>;
  requests: Array<{ id: string; incoming: boolean; user: FriendProfile }>;
  debts: SharedDebt[];
};
export function useFriends() {
  return useQuery({
    queryKey: ['friends'],
    queryFn: () => api<FriendsData>('/friends'),
    refetchInterval: 15000,
  });
}
export type Notice = {
  id: string;
  title: string;
  body: string;
  href: string;
  readAt: string | null;
  createdAt: string;
};
export function useNotifications() {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: () => api<{ notifications: Notice[]; unread: number }>('/friends/notifications'),
    refetchInterval: 15000,
  });
}
